/**
 * @generated SignedSource<<0585912e6496082e76246588f3aa7cc5>>
 * @relayHash eeee80e0ca082e77602866a2fde11d2d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/577.0.0-2026-09-14T09:04:59.021Z/presenceMutation

import { ConcreteRequest } from 'relay-runtime';
export type PresenceUpdateHeartbeatInput = {
  clientMutationId?: string | null;
  userOrSellerId: string;
};
export type presenceMutation$variables = {
  input: PresenceUpdateHeartbeatInput;
};
export type presenceMutation$data = {
  readonly presenceUpdateHeartbeat: {
    readonly __typename: "PresenceUpdateHeartbeatPayload";
  } | null;
};
export type presenceMutation = {
  response: presenceMutation$data;
  variables: presenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PresenceUpdateHeartbeatPayload",
    "kind": "LinkedField",
    "name": "presenceUpdateHeartbeat",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presenceMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presenceMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/577.0.0-2026-09-14T09:04:59.021Z/presenceMutation",
    "metadata": {},
    "name": "presenceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ec965aefa1f0316aaf7bdb2bbe357d7f";

export default node;
